import { render, staticRenderFns } from "./PublicationStatusPicker.vue?vue&type=template&id=1bc9adb8&"
import script from "./PublicationStatusPicker.vue?vue&type=script&lang=js&"
export * from "./PublicationStatusPicker.vue?vue&type=script&lang=js&"
import style0 from "./PublicationStatusPicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports